<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>团队管理</el-breadcrumb-item>
      <el-breadcrumb-item>小程序用户列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索栏 -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
          <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
        </div>
        <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="7">
              <el-input
                placeholder="请输入手机号"
                v-model="searchPhone"
                clearable
                @clear="handleSearch()"
                @keyup.enter.native="handleSearch()"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="7">
              <el-input
                placeholder="请输入User ID"
                v-model="searchUserId"
                clearable
                @clear="handleSearch()"
                @keyup.enter.native="handleSearch()"
                size="medium"
              >
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button @click="handleReset" size="medium">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 用户列表 -->
      <div class="table-scroll-wrapper">
        <el-table :data="userList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" align="center" />
        <el-table-column label="User ID" prop="short_id" align="center" />
        <el-table-column label="手机号" prop="phone" align="center" />
        <el-table-column label="上次登录时间" align="center">
          <template v-slot="scope">
            {{ dataFormat(scope.row.last_login_time) }}
          </template>
        </el-table-column>
        <el-table-column label="上次登录IP" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.last_login_ip">
              <el-tooltip 
                effect="dark" 
                :content="scope.row.last_login_ip" 
                placement="top"
              >
                <span>{{ scope.row.last_login_ip_location || '-' }}</span>
              </el-tooltip>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="设备" align="center">
          <template v-slot="scope">
            <span>{{ parseUserAgent(scope.row.user_agent) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效" prop="is_valid" width="100" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.is_valid ? 'success' : 'info'" effect="plain" size="medium">
              {{ scope.row.is_valid ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template v-slot="scope">
            <el-tooltip effect="dark" content="强制退出登录" placement="top" :enterable='false'>
                <el-button type="danger" icon="el-icon-coordinate" size="mini" :disabled="!scope.row.is_valid" @click="forceLogout(scope.row.user_id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onPageChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import * as UAParser from 'ua-parser-js';

export default {
  name: "MiniUsers",
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      userList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchPhone: '',
      searchUserId: '',
      loading: false
    }
  },
  created() {
    this.fetchUsers()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchUsers() {
      this.loading = true
      this.$http({
        method: 'get',
        url: 'mini-users',
        params: {
          page: this.pageNum,
          size: this.pageSize,
          phone: this.searchPhone || undefined,
          short_id: this.searchUserId || undefined
        }
      })
        .then(res => {
          this.loading = false
          if (!res.success) return this.$message.error(res.message)
          this.userList = res.data
          this.total = res.total
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.response?.data?.message || '获取用户列表失败')
        })
    },
    dataFormat(originVal) {
      if (!originVal) return '-'
      const dt = new Date(originVal)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')
      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}/${m}/${d} ${hh}:${mm}:${ss}`
    },
    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchUsers()
    },
    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchUsers()
    },
    handleSearch() {
      this.pageNum = 1
      this.fetchUsers()
    },
    handleReset() {
      this.searchPhone = ''
      this.searchUserId = ''
      this.pageNum = 1
      this.fetchUsers()
    },
    forceLogout(user_id) {
      this.$confirm('确定要强制该用户退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: '/mini-users/logout',
          data: { user_id }
        })
          .then(res => {
            if (!res.success) return this.$message.error(res.message)
            this.$message.success('强制退出登录成功')
            this.fetchUsers()
          })
          .catch(err => {
            this.$message.error(err.response?.data?.message || '操作失败')
          })
      }).catch(() => {})
    },
    parseUserAgent(ua) {
      if (!ua) return '-';
      const parser = new UAParser.UAParser(ua);
      const device = parser.getDevice();
      const os = parser.getOS();
      const browser = parser.getBrowser();

      // 只展示品牌/型号/系统/浏览器
      let parts = [];
      if (device.vendor) parts.push(device.vendor);
      if (os.name) parts.push(os.name + (os.version ? ' ' + os.version : ''));
      return parts.length ? parts.join(' / ') : '-';
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleResize() {
      this.checkIsMobile()
    }
  }
}
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .table-scroll-wrapper .el-table {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-table th,
  .table-scroll-wrapper .el-table td {
    padding: 8px 5px !important;
  }

  .pagination-wrapper {
    margin-top: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .pagination-wrapper .el-pagination {
    font-size: 10px;
    justify-content: flex-start;
    min-width: max-content;
  }

  .pagination-wrapper .btn-prev,
  .pagination-wrapper .btn-next {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 11px;
    padding: 0;
  }

  .pagination-wrapper .el-pager li {
    padding: 0 2px;
    min-width: 22px;
    height: 26px;
    line-height: 26px;
    font-size: 10px;
  }

  .pagination-wrapper .el-pagination__total {
    font-size: 10px;
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes {
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input {
    width: 60px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input__inner {
    height: 24px;
    font-size: 10px;
    padding: 0 5px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }
}
</style>